export type { TextToken } from './lib/core/tokens/theme/types';
export type { BackgroundToken, SupportedThemesT, Theme, ThemeName } from './lib/types';
export {
  RECRUITEE_THEME_LS_KEY,
  RECRUITEE_THEME_MIGRATED_LS_KEY,
  RECRUITEE_THEME_DEFAULT,
  providerEffectiveThemeFactory,
  injectEffectiveThemeFactory,
  SupportedThemes,
} from './lib/types';

export { Colors as ColorsLight } from './lib/core/tokens/theme/light/ts/colors';

export { ThemeImagePipe, ThemedImageTuple } from './lib/pipes/theme-image.pipe';
